
import {defineComponent} from "vue";
export default defineComponent({
  name: "AdvancedPanelSwitcher",
  computed: {
    iconIsAdvanced() : String {
      return "discover_tune"
    },
    iconIsNotAdvanced() : String {
      return "instant_mix"
    }
  },
  emits: ['toggleAdvanced'],
  props: {
    isAdvanced: {
      type: Boolean,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isReady: false,
  }),
  mounted() {
    this.isReady = true;
  },
  methods: {
  }
});
